import { isApiError } from './is-api-error';
/**
 *
 * Extracts the error message in form of `String` from an error object.
 *
 * Useful to extract the message when the error is of type `unknown`, which happens in `try .. catch` blocks.
 *
 * ### Usage :
 * ```
 *   const errorMessage = getErrorMessage(error)
 * ```
 */
export function getErrorMessage(error, defaultMessage) {
    const apiError = isApiError(error);
    if (apiError) {
        return error?.response?.data?.error?.message || error?.message;
    }
    else if (error instanceof Error) {
        return error?.message;
    }
    else if (defaultMessage) {
        return defaultMessage;
    }
    else if (typeof error === 'string') {
        return error;
    }
    return String(error);
}
//# sourceMappingURL=get-error-message.js.map